import { useEffect } from "react";
import PropTypes from "prop-types";
import {
    getToastStatusConfig,
    getToastDefaultMessage,
} from "../../utils/helpers";
import successIcon from "../../assets/icons/success-circle.svg";
import closeIcon from "../../assets/icons/close-circle.svg";
import failedIcon from "../../assets/icons/failed-circle.svg";
import fileIcon from "../../assets/icons/file_icon.svg";
import progressIcon from "../../assets/icons/progress-circle.svg";

// Icon mapping
const statusIcons = {
    success: successIcon,
    failed: failedIcon,
    progress: progressIcon,
};

const ToastNotification = ({
    files: _files,
    onClose,
    autoCloseDelay: _delay,
}) => {
    const files = _files ?? [];
    const autoCloseDelay = _delay ?? 10000;
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, autoCloseDelay);
        return () => clearTimeout(timer);
    }, [onClose, autoCloseDelay]);

    return (
        <div className="toast-container-fixed">
            <div className="toast-message">
                <p className="toast-text">{getToastDefaultMessage(files)}</p>
                <div className="toast-files">
                    {files.map((file) => {
                        const config = getToastStatusConfig(file.status);
                        return (
                            <div
                                className="toast-file"
                                key={`${file.fileName}-${file.status}`}
                            >
                                <div className="toast-file-wrapper">
                                    <img
                                        src={fileIcon}
                                        alt="File"
                                        width="18"
                                        height="16"
                                    />
                                    <div className="file-info">
                                        <p className="file-name">
                                            {file.fileName}
                                        </p>
                                        <div
                                            className={`status-wrapper ${config.className}`}
                                        >
                                            <span className="status-text">
                                                {config.text}
                                            </span>
                                            <img
                                                src={
                                                    statusIcons[file.status] ||
                                                    progressIcon
                                                }
                                                alt={file.status}
                                                width="16"
                                                height="16"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
            <button
                className="toast-close-btn"
                onClick={onClose}
                aria-label="Close notification"
            >
                <img src={closeIcon} alt="Close" width="16" height="16" />
            </button>
        </div>
    );
};

ToastNotification.propTypes = {
    files: PropTypes.arrayOf(
        PropTypes.shape({
            fileName: PropTypes.string.isRequired,
            status: PropTypes.oneOf(["success", "failed", "progress"])
                .isRequired,
        })
    ),
    onClose: PropTypes.func.isRequired,
    autoCloseDelay: PropTypes.number,
};

ToastNotification.defaultProps = {
    files: [],
    autoCloseDelay: 10000,
};

export default ToastNotification;
